// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3EQS-","colMin":"styles_colMin__2IhUL","colCheckbox":"styles_colCheckbox__2_9QF"};